import CyrillicToTranslit from 'cyrillic-to-translit';

export function openSidebar() {
  if (typeof window !== 'undefined') {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.setProperty('--SideNavigation-slideIn', '1');
  }
}

export function closeSidebar() {
  if (typeof window !== 'undefined') {
    document.documentElement.style.removeProperty('--SideNavigation-slideIn');
    document.body.style.removeProperty('overflow');
  }
}

export function toggleSidebar() {
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    const slideIn = window
      .getComputedStyle(document.documentElement)
      .getPropertyValue('--SideNavigation-slideIn');
    if (slideIn) {
      closeSidebar();
    } else {
      openSidebar();
    }
  }
}
export function snakeToCamelCase(str) {
  let parts = str.split('_')
  let first = parts[0]
  let rest = parts.slice(1).map(part => capitalizeFirstLetter(part))
  return [first, ...rest].join("")
}
export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const cyrillicToTranslitTJ = new CyrillicToTranslit({ preset: "tj" });
const cyrillicToTranslitRU = new CyrillicToTranslit({ preset: "ru" });
export function toSlug(str) {
  let translit = cyrillicToTranslitTJ.transform(str, '-');
  translit = cyrillicToTranslitRU.transform(str, '-');
  translit = translit.toLowerCase()
  translit = translit.replace(/[^a-z0-9\-]/g, '')
  translit = translit.replace(/\-+/g, '-'); // --- => -
  if (translit.endsWith('-')) translit = translit.slice(0, -1)
  return translit
}
export function updateErrors(field, error, setErrors) {
  setTimeout(() => setErrors(errors => ({ errors, [field]: error })), 10)
}
export function formatPrc(value, end = "%") {
  let num = parseFloat(value)
  if (isNaN(num)) return ""
  return (num * 100).toFixed(2) + end;
}

// 12345 to "12 345"
export function formatBigInt(num, separator = " ") {
  if (!Number.isInteger(num) || num < 0) {
    throw new Error("Only for positive integers")
  }
  let digits = [...num.toString()];
  let init = digits.length % 3;
  let chunks = [digits.slice(0, init).join("")];
  for (let i = init; i < digits.length; i += 3) {
    chunks.push(digits.slice(i, i + 3).join(""))
  }
  return chunks.filter(x => x).join(separator)
}

export const filterDups = (options) => {
  let used = new Set()
  let res = options.filter(x => {
    let is_used = used.has(x.id)
    used.add(x.id)
    return !is_used
  })
  return res
}

export function normalizeDomainsArray(list) {
  return list
    .map(d => d.trim())
    .filter(Boolean)
    .map(d => {
      let domain = d.replace(/^https?:\/\//i, '');
      domain = domain.split('/')[0];
      return domain;
    });
}

// [...chunks([1,2,3,4,5,6,7], 2)] is [[1,2], [3,4], [5,6], [7]]
export function* chunks(arr, n) {
  for (let i = 0; i < arr.length; i += n) {
    yield arr.slice(i, i + n);
  }
}